import React from "react";
import { Modal, ModalBody } from "../libraries/reactstrap";
import axios from "axios";

import { BACKEND_CONFIG } from "../config/consts";

class QuoteDescriptionModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      description: this.props.description,
    };
  }

  render() {
    return (
      <div>
        <Modal
          isOpen={this.props.isVisible}
          style={{ maxWidth: "680px", height: "340px" }}
        >
          <ModalBody style={{ padding: "0", borderRadius: "4px" }}>
            <div className="quote-description">
              <div className="description-header">
                {this.state.description !== ""
                  ? "Edit Quote Description"
                  : "Add Quote Description"}
              </div>
              <div className="description-body">
                <label>Please provide the description of the quote</label>
                <textarea
                  value={this.state.description}
                  onChange={(e) =>
                    this.setState({ description: e.target.value })
                  }
                />
              </div>
              <div className="actions">
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    axios
                      .post(
                        `${BACKEND_CONFIG.apiUrl}clients/${this.props.clientId}/quotes/${this.props.quoteId}`,
                        { description: this.state.description }
                      )
                      .then((data) => {
                        this.props.updateDescription(this.state.description);
                      });
                  }}
                  className="btn btn-primary save"
                >
                  Save
                </button>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    this.setState({
                      description: this.props.description,
                    });
                    this.props.close();
                  }}
                  className="btn btn-default skip"
                >
                  Cancel
                </button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default QuoteDescriptionModal;
